import React, { Fragment, useState, useContext, useEffect } from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import { withStyles, makeStyles } from '@material-ui/core/styles'
import {
  Button,
  Dialog,
  Grid,
  DialogContent,
  DialogActions,
  CircularProgress,
  Tooltip,
} from '@material-ui/core'
import { Cancel, VpnKey, Refresh, History } from '@material-ui/icons'
import { Alert } from '@material-ui/lab'
import axios from 'axios'
import format from 'date-fns/format'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const MuiDialogContent = withStyles((theme) => ({
  root: { padding: theme.spacing(2) },
}))(DialogContent)

const MuiDialogActions = withStyles((theme) => ({
  root: { margin: 0, padding: theme.spacing(1) },
}))(DialogActions)

export default function JobPassWord(props) {
  const classes = useStyles()
  const { urlServices, keyAplication } = useContext(UrlServicesContext)
  let keyAuthorization = localStorage.getItem('Session')

  const [loading, setLoading] = useState(true)
  const [regenerating, setRegenerating] = useState(false)
  const [activePassword, setActivePassword] = useState(null)
  const [logs, setLogs] = useState([])
  const [mensaje, setMensaje] = useState('')
  const [severity, setSeverity] = useState('success')
  const [openAlert, setOpenAlert] = useState(false)
  const [returnLogin, setReturnLogin] = useState(false)

  const jobId = props.jobId

  useEffect(() => {
    if (jobId) fetchData()
  }, [jobId])

  const fetchData = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${urlServices}job-passwords/job/${jobId}`, {
        headers: {
          application: keyAplication,
          Authorization: 'Bearer ' + keyAuthorization,
        },
      })
      setActivePassword(res.data.active)
      setLogs(res.data.logs || [])
    } catch (e) {
      if (e.response?.status === 401) {
        setTimeout(() => {
          localStorage.clear()
          setReturnLogin(true)
        }, 200)
      } else {
        setMensaje('Error al cargar la clave.')
        setSeverity('error')
        setOpenAlert(true)
      }
    } finally {
      setLoading(false)
    }
  }

  const handleRegenerate = async () => {
    setRegenerating(true)
    setOpenAlert(false)
    try {
      const res = await axios.put(
        `${urlServices}job-passwords/job/${jobId}/regenerate`,
        {},
        {
          headers: {
            application: keyAplication,
            Authorization: 'Bearer ' + keyAuthorization,
          },
        },
      )
      setMensaje('Clave actualizada con éxito.')
      setSeverity('success')
      setOpenAlert(true)
      fetchData()
    } catch (e) {
      if (e.response?.status === 401) {
        setTimeout(() => {
          localStorage.clear()
          setReturnLogin(true)
        }, 200)
      } else {
        setMensaje('Error al regenerar la clave.')
        setSeverity('error')
        setOpenAlert(true)
      }
    } finally {
      setRegenerating(false)
    }
  }

  if (returnLogin) return <Redirect to="/" />

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={props.open}
        onClose={props.exit}
        PaperProps={{ classes: { root: classes.DialogStyle } }}
      >
        <MuiDialogContent dividers>
          <Grid container spacing={2}>
            {/* Título */}
            <Grid item xs={12}>
              <div className={classes.titleCardFilter}>
                <VpnKey style={{ marginRight: 8, verticalAlign: 'middle' }} />
                Clave de acceso
              </div>
              <div className={classes.lineBottom}></div>
              <small style={{ marginTop: 2 }}>
                <b>Cargo:</b> {props.jobName}
              </small>
            </Grid>

            {/* Clave activa */}
            <Grid item xs={12}>
              {loading ? (
                <center>
                  <CircularProgress size={30} />
                </center>
              ) : (
                <center>
                  <div
                    style={{
                      fontSize: 48,
                      fontWeight: 'bold',
                      letterSpacing: 12,
                      padding: '20px 30px',
                      background: 'rgb(255, 244, 229)',
                      color: 'rgb(102, 60, 0)',
                      borderRadius: 12,
                      display: 'inline-block',
                      minWidth: 160,
                    }}
                  >
                    {activePassword ? activePassword.password : '----'}
                  </div>
                  {activePassword && (
                    <div style={{ marginTop: 8, fontSize: 11, color: '#888' }}>
                      Generada por:{' '}
                      <b>
                        {activePassword.user?.name}{' '}
                        {activePassword.user?.lastName}
                      </b>{' '}
                      el{' '}
                      {format(
                        new Date(activePassword.createdAt),
                        'dd-MM-yyyy HH:mm',
                      )}
                    </div>
                  )}
                </center>
              )}
            </Grid>

            {/* Botón regenerar */}
            <Grid item xs={12}>
              <center>
                <Tooltip title="Genera una nueva clave aleatoria de 4 dígitos">
                  <Button
                    variant="contained"
                    style={{
                      background: props.jobStatus === 2 ? "#ccc" : '#024242',
                      color: '#fff',
                      fontWeight: 'bold',
                    }}
                    startIcon={
                      regenerating ? (
                        <CircularProgress size={16} style={{ color: '#fff' }} />
                      ) : (
                        <Refresh />
                      )
                    }
                    onClick={handleRegenerate}
                    disabled={regenerating || loading || props.jobStatus === 2}
                  >
                    {regenerating ? 'Generando...' : 'Cambiar clave'}
                  </Button>
                </Tooltip>
                {props.jobStatus === 2 && (
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 11,
                      color: '#888',
                      textAlign: 'center',
                    }}
                  >
                    Este cargo está finalizado. No se puede cambiar la clave.
                  </div>
                )}
              </center>
            </Grid>

            {/* Alerta */}
            {openAlert && (
              <Grid item xs={12}>
                <Alert severity={severity}>{mensaje}</Alert>
              </Grid>
            )}

            {/* Historial */}
            <Grid item xs={12}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  marginBottom: 8,
                }}
              >
                <History style={{ fontSize: 18, color: '#555' }} />
                <b style={{ fontSize: 13, color: '#555' }}>
                  Historial de cambios ({logs.length})
                </b>
              </div>
              {logs.length === 0 ? (
                <div
                  style={{
                    fontSize: 12,
                    color: '#aaa',
                    textAlign: 'center',
                    padding: 16,
                  }}
                >
                  Sin historial de cambios
                </div>
              ) : (
                <div
                  style={{
                    maxHeight: 220,
                    overflowY: 'auto',
                    border: '1px solid rgb(241, 241, 241)',
                    borderRadius: 8,
                  }}
                >
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      fontSize: 12,
                    }}
                  >
                    <thead>
                      <tr style={{ background: '#F2F2F2', fontWeight: 'bold' }}>
                        <th
                          style={{ padding: '8px 12px', textAlign: 'center' }}
                        >
                          #
                        </th>
                        <th
                          style={{ padding: '8px 12px', textAlign: 'center' }}
                        >
                          Clave
                        </th>
                        <th style={{ padding: '8px 12px', textAlign: 'left' }}>
                          Usuario
                        </th>
                        <th
                          style={{ padding: '8px 12px', textAlign: 'center' }}
                        >
                          Fecha
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs.map((log, i) => (
                        <tr
                          key={log.id}
                          style={{
                            borderBottom: '1px solid rgb(241, 241, 241)',
                            background:
                              log.password === activePassword?.password
                                ? 'rgb(255, 244, 229)'
                                : 'transparent',
                          }}
                        >
                          <td
                            style={{
                              padding: '6px 12px',
                              textAlign: 'center',
                              color: '#888',
                            }}
                          >
                            {logs.length - i}
                          </td>
                          <td
                            style={{ padding: '6px 12px', textAlign: 'center' }}
                          >
                            <b style={{ letterSpacing: 4 }}>{log.password}</b>
                            {log.password === activePassword?.password && (
                              <span
                                style={{
                                  marginLeft: 6,
                                  fontSize: 10,
                                  background: '#024242',
                                  color: '#fff',
                                  borderRadius: 4,
                                  padding: '1px 5px',
                                }}
                              >
                                ACTUAL
                              </span>
                            )}
                          </td>
                          <td style={{ padding: '6px 12px' }}>
                            {log.user?.name} {log.user?.lastName}
                          </td>
                          <td
                            style={{
                              padding: '6px 12px',
                              textAlign: 'center',
                              color: '#888',
                            }}
                          >
                            {format(
                              new Date(log.createdAt),
                              'dd-MM-yyyy HH:mm',
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Grid>
          </Grid>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button onClick={props.exit}>
            <Cancel />
          </Button>
        </MuiDialogActions>
      </Dialog>
    </Fragment>
  )
}
